import { FormBase } from 'core/components';

export default class EligibilityStatusEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'ELIGIBILITY_STATUS.EDIT.NAME_LABEL',
                    placeholder: 'ELIGIBILITY_STATUS.EDIT.NAME_PLACEHOLDER',
                    rules: ['string', 'required'],
                },
                {
                    name: 'description',
                    label: 'ELIGIBILITY_STATUS.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'ELIGIBILITY_STATUS.EDIT.DESCRIPTION_PLACEHOLDER',
                    rules: ['string'],
                },
                {
                    name: 'includeInsuranceOnFacilityInvoice',
                    label: 'ELIGIBILITY_STATUS.EDIT.INCLUDE_INSURANCE_ON_FACILITY_INVOICE_LABEL',
                    type: 'checkbox',
                }
            ],
        };
    }
}
